import api from '../api'

const baseUrl = '/BizSchool/api/Admin'

const dadbananSettingProvider = {
  insertFirstBanner(payload) {
    return api.post(`${baseUrl}/FirstBanner`, payload)
  },

  insertSecondBanner(payload) {
    return api.post(`${baseUrl}/SecondBanner`, payload)
  },

  insertThirdBanner(payload) {
    return api.put(`${baseUrl}/ThirdBanner`, payload)
  },

  insertHomeCategory(payload) {
    return api.post(`${baseUrl}/HomeCategory`, payload)
  },

  updateHomeCategory(payload) {
    return api.put(`${baseUrl}/HomeCategory`, payload)
  },

  updateBanner(payload) {
    return api.put(`${baseUrl}/Banner`, payload)
  },

  getBanner(payload) {
    return api.get(`${baseUrl}/GetBanner/${payload.id}`)
  },
  getBannerType(payload) {
    return api.get(`${baseUrl}/GetBannerType/${payload.type}`)
  },
  getHomeCategory(home_category_id) {
    return api.get(`${baseUrl}/GetHomeCategory/${home_category_id}`)
  },

  deleteHomeCategory(home_category_id) {
    return api.delete(`${baseUrl}/HomeCategory/${home_category_id}`)
  },

  deleteBanner(id) {
    return api.delete(`${baseUrl}/Banner/${id}`)
  },
}

export default dadbananSettingProvider
